export default __webpack_public_path__ + "static/logo-9f868d0211fcf3152b4edcfaa3888cd9.png";